import $ from "jquery";

$(function () {
    var requiredCheckboxes = $(".options :checkbox[required]");
    requiredCheckboxes.change(function () {
        if (requiredCheckboxes.is(":checked")) {
            requiredCheckboxes.removeAttr("required");
        } else {
            requiredCheckboxes.attr("required", "required");
        }
    });
});

// Contact form
$("form").submit(function (event) {
    var recaptcha = $(".g-recaptcha-response").val();
    if (recaptcha === "") {
        event.preventDefault();
        $(".recaptcha-error").removeClass("d-none");
        $(".recaptcha-error").addClass("d-block");
    }
});
